import styled from "styled-components";
import Flex from "../Flex";
import {createContext, useEffect, useState} from "react";
import {ArrowIosDownward} from "@styled-icons/evaicons-solid";
import {motion} from "framer-motion";

const StyledDropdown = styled.div`
   .dropdown {
     color: ${props => props.theme.colors.text};
     &__title {
       font-size: 20px;
       font-weight: bold;
       cursor: pointer;
     }
     &__arrow-icon {
       height: 20px;
       fill: ${props => props.theme.colors.text};
     }
     &__items {
       overflow: hidden;
     }
   }
`

const dropdownItemsVariants = {
  initial: {
    height: 0,
  },
  open: {
    height: "auto",
    transition: {
      staggerChildren: 0.07,
      delayChildren: 0
    }
  },
  closed: {
    height: 0,
    transition: {
      when: "afterChildren",
      staggerChildren: 0.03,
      staggerDirection: -1
    }
  }
}

const collapsedMenuContextInitialState = {
  isOpen: false,
  toggle: () => {}
}

const CollapseMenuContext = createContext(collapsedMenuContextInitialState);

const CollapseMenu = ({ icon, title, children, isOpen = null, ...props }) => {
  const [isOpenState, setIsOpenState] = useState(false);
  const toggle = () => setIsOpenState(!isOpenState);

  useEffect(() => {
    if (isOpen !== null) {
      setIsOpenState(isOpen);
    }
  }, [isOpen]);

  return (
    <CollapseMenuContext.Provider
      value={{isOpenState: isOpenState, toggle: toggle}}
    >
      <StyledDropdown {...props}>
        <Flex className="dropdown__inner" direction={"column"}>
          <Flex className="dropdown__title" direction={"row"} align={"center"} onClick={toggle}>
            <div>{icon}</div>
            <div>{title}</div>
            <ArrowIosDownward
              as={motion.svg}
              className={`dropdown__arrow-icon`}
              variants={{
                open: {
                  rotate: -180,
                },
                closed: {
                  rotate: 0,
                },
              }}
              animate={isOpenState ? "open" : "closed"}
            />
          </Flex>
          <Flex
            as={motion.div}
            variants={dropdownItemsVariants}
            initial="initial"
            animate={isOpenState ? "open" : "closed"}
            className="dropdown__items"
            direction={"column"}
          >
            {children}
          </Flex>
        </Flex>
      </StyledDropdown>
    </CollapseMenuContext.Provider>
  );
};

export default CollapseMenu;